import { company } from '~/company/Company';

interface IntercomSettings {
  app_id: string;
  name?: string;
  email?: string;
  phone?: string;
  anonymous_id?: string;
  user_id?: string | number;
  [key: string]: any;
}

export type IntercomType = {
  (command: 'boot', settings: IntercomSettings): void;
  (command: 'shutdown' | 'hide' | 'show' | 'showMessages'): void;
  (command: 'update', settings?: IntercomSettings): void;
  (command: 'showNewMessage', content?: string): void;
  (...args: any[]): void;
};

declare global {
  interface Window {
    Intercom: IntercomType;
  }
}

export const useIntercom = () => {
  const openMessenger = () => {
    if (window.Intercom) {
      window.Intercom('showMessages');
    }
  };

  const bootIntercom = (settings?: Omit<IntercomSettings, 'app_id'>) => {
    if (window.Intercom) {
      window.Intercom('boot', {
        app_id: company.envVariables.REACT_APP_INTERCOM_ID,
        ...(settings ?? {}),
      });
    }
  };

  const updateIntercom = (settings: Omit<IntercomSettings, 'app_id'>) => {
    if (window.Intercom) {
      window.Intercom('update', {
        ...settings,
      });
    }
  };

  const shutdownIntercom = () => {
    if (window.Intercom) {
      window.Intercom('shutdown');
    }
  };

  return { openMessenger, bootIntercom, updateIntercom, shutdownIntercom };
};
